module.exports = __webpack_public_path__ + "static/media/feflix_logo.fc6a3867.png";